import React from 'react'
import './ModeratorAddPlayerPopupCard.css'
class ModeratorAddPlayerPopupCard extends React.Component
{
    handleChecked(isChecked){
        this.props.onSelectPlayer(this.props.player, isChecked.target.checked);
    }

    render() {
        if(this.props.isBusy){
            return <div className= 'moder-add-player-card-container-busy'>
                <div className='moder-add-player-card-text-busy'>
                    {this.props.player.firstname + " " + this.props.player.lastname}
                </div>
            </div>
        }
        else{
            return <div className= 'moder-add-player-card-container'>
                <div className='moder-add-player-card-text'>
                    {this.props.player.firstname + " " + this.props.player.lastname}
                </div>
                <div>
                    <label className="b-contain">
                        <input type="checkbox" className="moder-add-player-checkbox" checked={this.props.isSelected} onChange={this.handleChecked.bind(this)}/>
                        <div className="b-input"></div>
                    </label>
                </div>


            </div>
        }

    }
}
export default ModeratorAddPlayerPopupCard;